import type { ReactNode } from "react";
import "./styles.scss";

interface PhoneFrameProps {
  children: ReactNode;
  variant?: "isp" | "mvno";
  /** frame width in px (screen scales with it) */
  width?: number;
  className?: string;
  floating?: boolean;
}

/**
 * Device shell used across the marketing pages. Dark bezel + a gradient
 * "wallpaper" screen; the caller fills it with frosted app rows. No fake
 * status bar or keyboard — those belong to the real device.
 */
export const PhoneFrame = ({
  children,
  variant = "isp",
  width = 272,
  className = "",
  floating = false,
}: PhoneFrameProps) => {
  return (
    <div
      className={`phone-frame phone-frame--${variant} ${
        floating ? "phone-frame--floating" : ""
      } ${className}`}
      style={{ width }}
    >
      <div className="phone-frame__screen">{children}</div>
    </div>
  );
};
